const list = ['ArtObjects'];
const categoryValues = ['ArtObjectCategoryValues'];

export { list, categoryValues };
